import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const registrationFormSchema = () => {
  const { t } = useTranslation();

  return yup.object().shape({
    e03_id: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    e03_businessname: yup.string(),
    e03_afm: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    d05_descr: yup.string(),
    m01_username: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(7, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 7 χαρακτήρες")),
    m01_password1: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(7, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 7 χαρακτήρες")),
    m01_password2: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(7, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 7 χαρακτήρες"))
      .oneOf([yup.ref("m01_password1"), null], t("Ο κωδικός δεν είναι ίδιος")),
    m01_email: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .email(t("Μη έγκυρο mail")),
    m01_lastname: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(2, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο δύο χαρακτήρες")),
    m01_firstname: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(2, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο δύο χαρακτήρες")),
    m01_phone: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(10, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 10 χαρακτήρες"))
      .max(15, t("Το πεδίο πρέπει να είναι μικρότερο απο 15 χαρακτήρες")),
  });
};
